import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogWebsitesComponent } from './change-log-websites.component';

@NgModule({
  declarations: [ChangeLogWebsitesComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogWebsitesComponent],
})
export class ChangeLogWebsitesModule {}
